import { ViewStream } from "spyne";
import { UIHeaderHamburgerView } from "components/ui/ui-heaader-hamburger-view";
import { NavigationTraits } from "traits/navigation-traits";
import { AuthView } from "components/auth/auth-view";

export class UIHeaderView extends ViewStream {
  constructor(props = {}) {
    props.id = "app-header";
    props.sendLifecyleEvents = true;
    props.traits = NavigationTraits;
    props.data.links = UIHeaderView.mainMenuLinks(); // AppDataTraits.api$GetNavLinks(1);

    //if (localStorage.getItem('showTheLogin') === 'true'){
      props.data.links.pageLinks.push(   {
        pageId: "plans",
        title: "Plans",
        endRoute: "true",
        href: "/plans",
        navLevel: 1,
      })
    //}


    props.data.headerText = props.data.uiProps.header;
    props.template = require("./templates/ui-header.tmpl.html");
    super(props);
  }

  addActionListeners() {
    // return nexted array(s)
    return [
      ["CHANNEL_ROUTE_.*EVENT", "onRouteChangeEvent"],
      ["CHANNEL_WINDOW_.*SCROLL_EVENT", "nav$OnWindowShadeEvent"],
    ];
  }

  onRouteChangeEvent(e) {
    const { isDeepLink, routeData } = e.payload;
    if (routeData === undefined) {
      return;
    }

    const { pageId } = routeData;
    if (isDeepLink === true) {
    }
    const activeSel = `a.nav.${pageId}`;

    //this.props.el$("a.nav").removeClass('selected');

    this.props.el$("a.nav").setActiveItem("selected", activeSel);
  }

  broadcastEvents() {
    // return nexted array(s)
    return [["a.nav.nav-page", "click"]];
  }

  onRendered() {
    this.appendView(new UIHeaderHamburgerView());
    this.appendView(new AuthView(), ".auth-container");
    this.addChannel("CHANNEL_ROUTE");
    this.addChannel("CHANNEL_WINDOW");
  }

  static mainMenuLinks() {
    return {
      pageLinks: [
        {
          pageId: "docs",
          navLevel: 1,
          endRoute: "true",
          title: "Docs",
          href: "/docs/intro",
        },
        {
          pageId: "reference",
          stage: "viewstream",
          title: "Reference",
          endRoute: "true",
          href: "/reference/viewstream",
          navLevel: 1,
        },
        {
          pageId: "blog",
          title: "Blog",
          endRoute: "true",
          href: "/blog",
          navLevel: 1,
        },

        {
          pageId: "configure",
          title: "App Builder",
          endRoute: "true",
          href: "/configure",
          navLevel: 1,
        }

      ],

      githubLink: {
        pageId: "github",
        endRoute: "true",
        title: "",
        logo:
          '<svg height="32" aria-hidden="true" viewBox="0 0 16 16" version="1.1" width="32" data-view-component="true" class="octicon octicon-mark-github v-align-middle">\n' +
          '    <path d="M8 0c4.42 0 8 3.58 8 8a8.013 8.013 0 0 1-5.45 7.59c-.4.08-.55-.17-.55-.38 0-.27.01-1.13.01-2.2 0-.75-.25-1.23-.54-1.48 1.78-.2 3.65-.88 3.65-3.95 0-.88-.31-1.59-.82-2.15.08-.2.36-1.02-.08-2.12 0 0-.67-.22-2.2.82-.64-.18-1.32-.27-2-.27-.68 0-1.36.09-2 .27-1.53-1.03-2.2-.82-2.2-.82-.44 1.1-.16 1.92-.08 2.12-.51.56-.82 1.28-.82 2.15 0 3.06 1.86 3.75 3.64 3.95-.23.2-.44.55-.51 1.07-.46.21-1.61.55-2.33-.66-.15-.24-.6-.83-1.23-.82-.67.01-.27.38.01.53.34.19.73.9.82 1.13.16.45.68 1.31 2.69.94 0 .67.01 1.3.01 1.49 0 .21-.15.45-.55.38A7.995 7.995 0 0 1 0 8c0-4.42 3.58-8 8-8Z"></path>\n' +
          "</svg>",
        href: "//github.com/spynejs/spyne",
        navLevel: 1,
      },
    };
  }
}
